import React, { ButtonHTMLAttributes } from 'react';

import { Box, Typography, IconSvg, helperTextEllipsis } from '@utex/ui-kit';
import { Icon, SelectButton, SubIcon } from './styles';

export interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  name: string;
  subIcon?: string;
}

export type SelectProps = Omit<Props, 'icon' | 'name' | 'subIcon'>;

export const SelectItem = (props: Props) => {
  return (
    <SelectButton type="button" {...props}>
      <Box marginRight="auto" css={helperTextEllipsis}>
        <Icon src={props.icon} alt="card" />
        <Typography.Text size="M-Compact-Height">{props.name}</Typography.Text>
      </Box>

      {props.subIcon && <SubIcon src={props.subIcon} />}
      <IconSvg src="dropdown" />
    </SelectButton>
  );
};
